import AMapPolygon from './a-map-polygon'

export default AMapPolygon
